'use client'

import { useEffect } from 'react'
import { AlertTriangle, RotateCcw } from 'lucide-react'

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {
  useEffect(() => {
    console.error('Application error', error.digest || error.name)
  }, [error])

  return (
    <main className="flex min-h-[70vh] items-center justify-center px-6 pt-20 text-center">
      <div className="max-w-md space-y-5">
        <AlertTriangle className="mx-auto text-accent" size={36} aria-hidden="true" />
        <h1 className="text-2xl font-bold">페이지를 불러오지 못했습니다</h1>
        <p className="text-sm text-foreground/60">잠시 후 다시 시도해 주세요. 계속되면 운영자에게 문의해 주세요.</p>
        <button type="button" onClick={reset} className="inline-flex h-11 items-center gap-2 rounded-md bg-accent px-5 font-semibold text-white">
          <RotateCcw size={17} aria-hidden="true" /> 다시 시도
        </button>
      </div>
    </main>
  )
}
